exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "confirm-close-modal .modal-content.responsiveMobile{padding-left:30px;padding-right:30px;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center}confirm-close-modal .modal-body{margin:20px 0;text-align:center}confirm-close-modal .modal-body .description{font-size:24px}confirm-close-modal .modal-body .small-description{font-size:15px;margin:0 80px 20px}confirm-close-modal .modal-footer{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/components/confirmCloseModal/confirmCloseModal.scss
// module id = 960
// module chunks = 0